module.exports = function requestMic() {
  console.log('requesting mic')
  return navigator.mediaDevices.getUserMedia( { audio: true } )
}
